import actionNames from "action-names";

export const icons = actionNames("icons"),
    iconConfig = actionNames("iconConfig"),
    SET_SEARCH = "SET_SEARCH",
    UPDATE_LIST = "UPDATE_LIST",
    UPDATE_STATUS = "UPDATE_STATUS",
    UPDATE_INVIEW = "UPDATE_INVIEW",
    RESET_LIST = "RESET_LIST",
    SET_ICON_STYLE = "SET_ICON_STYLE";
